import React, { Fragment } from "react";
import cx from "classnames";
import { useSelector } from "react-redux";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import HeaderLogo from "../AppLogo";
import UserBox from "./Components/UserBox";
import ButtonChangeLanguage from "components/atoms/ButtonChangeLanguage";

const Header = () => {
  const { headerBackgroundColor, enableMobileMenuSmall, enableHeaderShadow } = useSelector(
    (state) => ({
      headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
      enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
      enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    })
  ); 

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        className={cx("app-header", headerBackgroundColor, {
          "header-shadow": enableHeaderShadow,
        })}
        transitionName="HeaderAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />
        <div
          className={cx("app-header__content", {
            "header-mobile-open": enableMobileMenuSmall,
          })}
        >
          <div className="app-header-left"></div>
          <div className="app-header-right">
            <ButtonChangeLanguage isMobile={false} />
            <UserBox isMobile={false}/>
          </div>
        </div>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default Header;
